var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"trade-buy-sell-amount-picker"},_vm._l((_vm.buttons),function(btn){return _c('button',{key:btn.name,staticClass:"trade-buy-sell-amount-picker__button",class:{
      'trade-buy-sell-amount-picker__button--active' : _vm.currentButton === btn,
      'trade-buy-sell-amount-picker__button--big': _vm.bigSize
    },attrs:{"type":"button"},on:{"click":function($event){return _vm.clickHandler(btn)}}},[_c('span',[_vm._v("\n      "+_vm._s(btn.name)+"\n    ")])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }